import { logWrapper } from '../../utils';
import swal from 'sweetalert2';
import jQuery from 'jquery';

export default {
  uploadsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$filter',
    '$timeout',
    '$state',
    'fileUploadService',
    'fileCheckinUploadService',
    'fileReplaceUploadService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $filter,
      $timeout,
      $state,
      fileUploadService,
      fileCheckinUploadService,
      fileReplaceUploadService
    ) {
      'use strict';

      function onToogleSidebar(event, toogle) {
        var isOpen = jQuery('#chat-trigger').hasClass('open');
        if (toogle !== isOpen) {
          jQuery('#chat-trigger').click();
        }
      }

      function count() {
        var items = $scope.uploader.queue.filter(function (item) {
          return item.revision.uploading && !item.isUploaded;
        });

        $scope.uploaderCheckin.queue.filter(function (item) {
          if (item.revision.uploading && !item.isUploaded) {
            items.push(true);
          }
        });
        $scope.uploaderReplace.queue.filter(function (item) {
          if (item.revision.uploading && !item.isUploaded) {
            items.push(true);
          }
        });
        return items.length;
      }

      function remainingFilesMessage() {
        return String.format(
          $filter('translate')('REMAINING X FILES TO UPLOAD'),
          [$scope.count()]
        );
      }

      function getItems() {
        var items = $scope.uploader.queue;
        items = items.concat($scope.uploaderCheckin.queue);
        items = items.concat($scope.uploaderReplace.queue);

        return items.filter($scope.itemFilter);
      }

      function itemFilter(item) {
        return !item.isUploaded;
      }

      function hasItems() {
        return (
          $scope.uploader.queue.filter($scope.itemFilter).length > 0 ||
          $scope.uploaderCheckin.queue.filter($scope.itemFilter).length > 0 ||
          $scope.uploaderReplace.queue.filter($scope.itemFilter).length > 0
        );
      }

      function uploader_onErrorItem(fileItem, response, status) {
        var i = $scope.uploader.queue.filter(function (e) {
          return e === fileItem;
        });
        i[0].isError = true;
        i[0].isUploading = false;
        i[0].isUploaded = false;
        i[0].errorDetails = $scope.getError(status);
      }

      function uploaderCheckin_onErrorItem(fileItem, response, status) {
        var i = $scope.uploaderCheckin.queue.filter((e) => e === fileItem);
        i[0].isError = true;
        i[0].isUploading = false;
        i[0].isUploaded = false;
        i[0].errorDetails = $scope.getError(status);
      }

      function uploaderReplace_onErrorItem(fileItem, response, status) {
        var i = $scope.uploaderReplace.queue.filter((e) => e === fileItem);
        i[0].isError = true;
        i[0].isUploading = false;
        i[0].isUploaded = false;
        i[0].errorDetails = $scope.getError(status);
      }

      function getError(status) {
        switch (status) {
          case 0:
            return $filter('translate')('WEBAPI UNAVAILABLE');
          case 401:
            return $filter('translate')('USER UNAUTHORIZED');
          case 400:
            return $filter('translate')('ERROR IN FILE DATA');
          case 403:
            return $filter('translate')('GBS LIMIT REACHED');
          default:
            return $filter('translate')('INTERNAL SERVER ERROR');
        }
      }

      function remove(item) {
        swal
          .fire({
            title: $filter('translate')('REMOVE THE FILE'),
            text: $filter('translate')('CONFIRM REMOVE FILE'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            closeOnCancel: false,
            showLoaderOnConfirm: true,
            preConfirm: function () {
              return new Promise(function (resolve) {
                $scope.removeFile(item);
                $scope.removeFileCheckin(item);
                resolve();
              });
            },
          })
          .then(function () {
            $timeout(function () {
              $rootScope.$broadcast('toogleSidebar', true);
            }, 200);
          });
      }

      function removeFile(item) {
        if ($scope.uploader.getIndexOfItem(item) >= 0) {
          $scope.uploader.removeFromQueue(item);
        }

        if (!$scope.hasItems()) {
          $state.reload();
          $rootScope.$broadcast('toogleSidebar', false);
        }
      }

      function removeFileCheckin(item) {
        if ($scope.uploaderCheckin.getIndexOfItem(item) >= 0) {
          $scope.uploaderCheckin.removeFromQueue(item);
        }

        if (!$scope.hasItems()) {
          $state.reload();
          $rootScope.$broadcast('toogleSidebar', false);
        }
      }

      function cancel(item) {
        swal
          .fire({
            title: $filter('translate')('CANCEL SEND'),
            text: $filter('translate')('CONFIRM CANCEL SEND'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showLoaderOnConfirm: true,
            preConfirm: function () {
              return new Promise(function (resolve) {
                $scope.removeFile(item);
                $scope.removeFileCheckin(item);
                resolve();
              });
            },
          })
          .then(function () {
            $timeout(function () {
              $rootScope.$broadcast('toogleSidebar', true);
            }, 200);
          });
      }

      function retry(item) {
        item.isError = false;
        item.upload();
      }

      function run() {
        try {
          $scope.uploader = fileUploadService.getUploader();
          $scope.uploaderCheckin = fileCheckinUploadService.getUploader();
          $scope.uploaderReplace = fileReplaceUploadService.getUploader();

          $scope.$on(
            'toogleSidebar',
            logWrapper(
              onToogleSidebar,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.count = logWrapper(
            count,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.remainingFilesMessage = logWrapper(
            remainingFilesMessage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getItems = logWrapper(
            getItems,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.itemFilter = logWrapper(
            itemFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hasItems = logWrapper(
            hasItems,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.uploader.onErrorItem = logWrapper(
            uploader_onErrorItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.uploaderCheckin.onErrorItem = logWrapper(
            uploaderCheckin_onErrorItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.uploaderReplace.onErrorItem = logWrapper(
            uploaderReplace_onErrorItem,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getError = logWrapper(
            getError,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.remove = logWrapper(
            remove,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeFile = logWrapper(
            removeFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeFileCheckin = logWrapper(
            removeFileCheckin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.retry = logWrapper(
            retry,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
